//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/MechanicalRouting.js";
import "../no/Builder.js";
import "../no/SelectNXObjectList.js";
import "../no/Expression.js";
import "../Tooling/Tooling.SelectReuseLibraryItemBuilder.js";
import "../no/Expression.js";
import "../no/SelectObjectList.js";
import "../no/Tooling.js";
let d=[[[1,"FacesToReinforce",0,"SelectNXObjectList",0],[0,"HeightCount",1,0],[1,"HeightEndGap",0,"Expression",0],[1,"SelectReuseItem",0,"Tooling.SelectReuseLibraryItemBuilder",0],[0,"WidthCount",1,0],[1,"WidthEndGap",0,"Expression",0]],[],[]];
SPLM.MechanicalRouting.DuctReinforcementContainerBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.MechanicalRouting.DuctReinforcementContainerBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;